import Phaser from 'phaser';
import gameData, { EVEN_GAME_MODE, ODD_GAME_MODE } from '../gameData';
import IntroScreenBase from './IntroScreenBase';

export default class IntroOddEvenScreen extends IntroScreenBase {
  create() {
    const evens = []; const odds = [];
    for (let i = 1; i < 20; i++) {
      if (i % 2) {
        odds.push(i);
      }
      else {
        evens.push(i);
      }
    }
    if (gameData.gameMode === ODD_GAME_MODE) {
      this.displayNum = odds[Phaser.Math.Between(0,odds.length - 1)];
    }
    else {
      this.displayNum = evens[Phaser.Math.Between(0,evens.length - 1)];
    }

    super.create();

    if (gameData.gameMode === null) {
      gameData.gameMode = Phaser.Math.Between(1,2) === 1 ? ODD_GAME_MODE : EVEN_GAME_MODE;
    }

    this.lblInstructions.text = `SLICE THE ${gameData.gameMode.toUpperCase()} NUMBERS`;
  }
}